import React, { useState } from "react";
import DietitianSupport from "../../molecules/Dietitian";
import { CTAButton } from "./Button";
import { Limitations } from "./Limitations";
import { Wrap, Inner, Alert } from "./styles";
import { selectedEntreesCounter, checkForSoldOuts, setBreakfastsLimitation, setEntreesLimitation } from "./utils";
import { selectedBreakfastsCounter, populateMealTypes } from "./../../../utils/functions";

function CTA(props) {
  const {
    isLoaded,
    selectedMeals,
    limitations,
    configPageUrl,
    dietitian,
    handleDietitianChange,
    mode,
    programType,
    mealSettings,
    charge,
    dietType,
  } = props;

  const [loading, setLoading] = useState(false);

  const handleCTAClick = () => {
    props.handleCTAClick();
    setLoading(true);
  };

  const handleClickEditQuantity = (e) => {
    e.preventDefault();
    props.handleClickEditQuantity();
  };

  const selectedBreakfasts = selectedBreakfastsCounter(selectedMeals);
  const selectedEntrees = selectedEntreesCounter(selectedMeals);
  const soldOuts = checkForSoldOuts(selectedMeals, charge);
  const breakfastsLimitation = setBreakfastsLimitation(dietType, limitations);
  const entreesLimitation = setEntreesLimitation(limitations);
  const overallLimitations = breakfastsLimitation + entreesLimitation;
  const overallSelected = selectedBreakfasts + selectedEntrees;
  const itemsInCart = populateMealTypes(selectedMeals);

  return (
    <Wrap>
      {soldOuts && (
        <Inner className="inner-bl disabled">
          <Alert className="alert">!</Alert>This item is sold out. Please select a different item.
        </Inner>
      )}
      <Limitations
        isLoaded={isLoaded}
        configPageUrl={configPageUrl}
        mode={mode}
        mealSettings={mealSettings}
        overallSelected={overallSelected}
        overallLimitations={overallLimitations}
        handleClickEditQuantity={handleClickEditQuantity}
        loading={loading}
        soldOuts={soldOuts}
        selectedBreakfasts={selectedBreakfasts}
        breakfastsLimitation={breakfastsLimitation}
        selectedEntrees={selectedEntrees}
        entreesLimitation={entreesLimitation}
        itemsInCart={itemsInCart}
      />
      {/* {programType !== "Program" && <DietitianSupport dietitian={dietitian} handleDietitianChange={handleDietitianChange} />} */}
      <CTAButton
        mode={mode}
        mealSettings={mealSettings}
        overallSelected={overallSelected}
        overallLimitations={overallLimitations}
        handleCTAClick={handleCTAClick}
        loading={loading}
        soldOuts={soldOuts}
        selectedBreakfasts={selectedBreakfasts}
        breakfastsLimitation={breakfastsLimitation}
        selectedEntrees={selectedEntrees}
        entreesLimitation={entreesLimitation}
        itemsInCart={itemsInCart}
      />
    </Wrap>
  );
}

export default CTA;
